import decorateWithEvents from 'utils/decorateWithEvents';
import { cancelCurrentCalls } from './dataProvider';
import axios from 'axios'

const errors = decorateWithEvents({
    status408: 'status408',
    status403: 'status403',
    status420: 'status420',
    status490: 'status490',
    handle(error) {
      if (error.response) {
        // console.log(error.response.data);
        // console.log(error.response.status);
        // console.log(error.response.headers);
      }
  
      if (axios.isCancel(error)) {
        console.log('Axios request canceled');
        // Return resolved promise to prevent error overlay for canceled requests
        return Promise.resolve({ handled: true, canceled: true, message: error.message });
      }

      let message = '';

      try {
        message = error.response.data.message || 'Unknown Error'
      }
      catch (e) {
        message = 'Server Error1'
      }

      let status = '';

      // console.log(error);

      try {
        status = error.response.status
      }
      catch (e) {
        status = '500';
      }

      // console.log('current-status: ' + status);

      if (status === 408) {
        console.log('handle-408');
        cancelCurrentCalls();
        this.emit(this.status408);
        // Return resolved promise to prevent error overlay
        return Promise.resolve({ handled: true, status: 408, message });
      }
      else if (status === 403) {
        console.log('handle-403');
        this.emit(this.status403);
        // Reject so callers can handle permission errors without logging out
        const apiError = new Error(message || 'Forbidden');
        apiError.status = 403;
        return Promise.reject(apiError);
      }
      else if (status === 420) {
        cancelCurrentCalls();
        console.log('handle-420');
        this.emit(this.status420);
        // Return resolved promise to prevent error overlay
        return Promise.resolve({ handled: true, status: 420, message });
      }
      else if (status === 490) {
        console.log('handle-490');
        this.emit(this.status490);
        // Return resolved promise to prevent error overlay
        return Promise.resolve({ handled: true, status: 490, message });
      }

      const apiError = new Error(`Error: ${message}`);
      // Attach HTTP status and original response for richer debugging in callers
      apiError.status = status;
      try {
        apiError.response = error.response;
      } catch (e) {
        apiError.response = null;
      }
      return Promise.reject(apiError);
    }
});

export default errors;